export const LOGIN = 'LOGIN/LOGIN';
export const LOGIN_SUCCESS = 'LOGIN/LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN/LOGIN_ERROR';
export const SET_FIELD = 'LOGIN/SET_FIELD';
export const SET_TOKENS = 'LOGIN/SET_TOKENS';
export const CLEAR_TOKENS = 'LOGIN/CLEAR_TOKENS';
export const SET_TYPE = 'LOGIN/SET_TYPE';
export const RESET_STATE = 'LOGIN/RESET_STATE';